import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Paper, Tooltip, Typography } from '@mui/material'

import { Error } from '@mui/icons-material'
import { colors } from '@/theme/colors.theme'
import { useStyles } from './style'

type CustomStepTab = {
  id: number
  title: string
  label: string
  titleIcon?: JSX.Element
  childrenComponent: React.ReactNode
  disabled?: boolean
  required?: boolean
  refreshFunction?: () => void
}

type Props = {
  tabsArray: CustomStepTab[]
  children: JSX.Element
}

export const CustomStep = ({ tabsArray, children }: Props) => {
  const { classes } = useStyles()

  const { t } = useTranslation()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Box>
        {tabsArray.map((tabItem) => (
          <Box sx={{ display: 'flex', marginBottom: 3 }} key={tabItem.id}>
            <Box sx={{ width: 300, display: 'flex', alignItems: 'start' }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontWeight="700">
                  {tabItem.title.toUpperCase()}
                </Typography>
                {tabItem.required !== undefined &&
                  tabItem.required &&
                  tabItem.disabled && (
                    <Box height={20} pl={1}>
                      <Tooltip
                        title={`${t('messages.incompleteFields')}`}
                        placement="top"
                        arrow
                      >
                        <Error className="red small" />
                      </Tooltip>
                    </Box>
                  )}
              </Box>
            </Box>
            <Box
              component={Paper}
              sx={{
                backgroundColor: colors.paper2,
                width: 'calc(100% - 300px)',
                borderRadius: 4,
                padding: 3,
              }}
            >
              {tabItem.childrenComponent}
            </Box>
          </Box>
        ))}
      </Box>
      <Box className={classes.children}>{children}</Box>
    </Box>
  )
}
